export enum DataHooks {
  WeeklyTimeSlotsLayout = 'weekly-time-slots-layout',
  Timezone = 'timezone',
}
